import { render, staticRenderFns } from "./examinePropertyRightRegistration.vue?vue&type=template&id=71b0dc06&scoped=true"
import script from "./examinePropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./examinePropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./examinePropertyRightRegistration.vue?vue&type=style&index=0&id=71b0dc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0dc06",
  null
  
)

export default component.exports